module.exports = __webpack_public_path__ + "img/thumb_aula31.d5f51838.jpg";